<template>
  <div class="editor-container">
    <save-document-dialog :isOpen.sync="openSaveDocumentModal" @saveAsDocument="saveAsDocument" @keepAsDraft="keepAsDraft"
      :isSavingDocGo="isSavingDocGo" :isSavingDraft="isSavingDraft"
      @close="openSaveDocumentModal = false"></save-document-dialog>
    <v-card color="grey lighten-3">
      <v-toolbar>
        <v-layout align-center>

          <back-button-to-folder @openSaveDocumentModal="openSaveDocumentModal = true" />

          <v-layout column class="ml-2">
            <span class="document-type-header">{{ fileStateName(this.documentToEdit.document_state) }}</span>
            <v-tooltip class="document-type-text text-truncate pr-2" max-width="500" nudge-right>
              <span slot="activator">
                {{ get(this.documentToEdit, 'document_type.name') }}
              </span>
              <span>{{ get(this.documentToEdit, 'document_type.name') }}</span>
            </v-tooltip>
          </v-layout>
          <!-- <span>Ultima alteração {{get(this.documentToEdit, 'updatedAt')}}</span> -->
          <v-btn color="success" @click="saveDocument" :loading="isSavingDocGo">
            <v-icon left>save</v-icon>Salvar
          </v-btn>
        </v-layout>
      </v-toolbar>
      <v-layout class="editor white">
        <editor :init="editorOptions" id="1" :value="html" @input="html = $event"></editor>
        <fields-sidebar @selectField="addField" @changeDocumentFieldValue="changeDocumentFieldValue" />
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import BackButtonToFolder from "@/components/document/editor/BackButtonToFolder";
import Editor from '@tinymce/tinymce-vue';
import FieldsSidebar from '@/components/document/editor/FieldsSidebar';
import SaveDocumentDialog from '@/components/document/editor/SaveDocumentDialog';
import TINYMCE_OPTIONS from '@/constants/TINYMCE_OPTIONS';
// import nonEditableTinyMce from '@/utils/nonEditableTinyMce';
import { get, last, find, isEmpty, forEach, concat, map } from 'lodash';
import colors from 'vuetify/es5/util/colors';
import { format, isValid } from 'date-fns';
import formatString from 'format-string-by-pattern';
import fileStateName from '@/mixins/file-state-name';

export default {
  name: 'document-editor',
  props: ['folderId', 'id'],
  components: { Editor, FieldsSidebar, SaveDocumentDialog, BackButtonToFolder },
  data() {
    return {
      editorOptions: TINYMCE_OPTIONS(),
      // html: "Teste!! documento número <span class='mceNonEditable'>123</span>"
      html: ' ',
      isSavingDraft: false,
      isSavingDocGo: false,
      isSavingMinute: false,
      documentFields: [],
      openSaveDocumentModal: '',
    };
  },
  computed: {
    documentToEdit() {
      return this.$store.getters.documentToEdit;
    },
    filledFields() {
      return get(
        last(this.documentToEdit.document_versions),
        'filled_fields',
        {},
      );
    },
    routeParams() {
      return this.$router.currentRoute.params;
    },
    queryParams() {
      return this.$router.currentRoute.query;
    },
  },
  methods: {
    get,
    fileStateName,
    parseHtml() {
      const html = this.html;
      // const params = html.match(/#{[a-záàâãéèêíïóôõöúçñ_ ]+}/gim);
      return html.replace(/#{[a-záàâãéèêíïóôõöúçñ_ ]+}/gim, (param) => {
        const [paramName] = param.match(/[a-záàâãéèêíïóôõöúçñ_ ]+/gim);
        const field = this.getField(paramName);
        if (field === undefined) {
          return param;
        }
        if (field.editable === true) {
          return this.formatFieldValue(paramName, field.type);
        }
        return `<span data-field class="mceNonEditable" style="${this.fieldStyle(field)}" id="${field.field_name}">${this.formatFieldValue(paramName, field.type)}</span>`;
      });
    },
    reparseHtml() {
      const html = this.html;
      const reparsed = html.replace(
        /(<span (.*?)class="mceNonEditable")(.*?)(<\/span>)/gm,
        (span) => {
          const [paramName] = span.match(/id="(.*?)"/gm) || [];
          console.log(`#{${paramName.replace(/id=|"/gm, '')}}`)
          return `#{${paramName.replace(/id=|"/gm, '')}}`;
        },
      );
      return reparsed;
    },
    filledFieldsWithoutCurrency(fields) {
      const currencyExp = new RegExp(/R\$ /);
      let filledFields = { ...fields };
      forEach(filledFields, (item, index) => {
        const field = {};
        if (currencyExp.test(item)) {
          field[index] = item.replace(currencyExp, '');
        } else {
          field[index] = item;
        }
        filledFields = { ...filledFields, ...field };
      });
      return filledFields;
    },
    keepAsDraft() {
      this.isSavingDraft = true;
      this.$store
        .dispatch('keepAsDraft', {
          id: this.id,
          raw: this.reparseHtml(),
          filledFields: this.filledFieldsWithoutCurrency(this.filledFields),
          documentState: this.documentToEdit.document_state,
        })
        .then(() => {
          this.onRequestSuccess('Documento salvo com sucesso!');
        })
        .catch((err) => {
          this.onRequestError(err);
        })
        .finally(() => {
          this.isSavingDraft = false;
        });
    },
    saveAsDocument() {
      let documentState = '';

      if (this.documentToEdit.document_state === 'draft') {
        documentState = 'document_docgo';
      } else if (this.documentToEdit.document_state === 'minute_draft') {
        documentState = 'minute';
      }

      this.isSavingDocGo = true;
      this.$getLocation()
        .then((coords) => {
          this.$store
            .dispatch('saveAsDocument', {
              id: this.id,
              raw: this.reparseHtml(),
              filledFields: this.filledFieldsWithoutCurrency(this.filledFields),
              documentState,
              geolocation: `${coords.lat}, ${coords.lng}`,
            })
            .then(() => {
              const { params } = this.$router.currentRoute;
              if (documentState === 'doccument_docgo') {
                this.onRequestSuccess('Documento salvo com sucesso!');
              } else if (documentState === 'minute') {
                this.onRequestSuccess('Minuta salva com sucesso!');
              }
              this.$router.push(`/pastas/${params.folderId}/show`);
            })
            .catch((err) => {
              this.onRequestError(err);
            })
            .finally(() => {
              this.isSavingDocGo = false;
            });
        })
        .catch(() => {

        });
    },
    onRequestSuccess(message) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'success',
        message,
        button: { show: true, text: 'Fechar', message: '' },
        timeout: 6000,
      });

      this.openSaveDocumentModal = false;
    },
    onRequestError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: err.response.data[0],
        messageIcon: 'mdi-alert-outline',
      });
    },
    getField(fieldName) {
      return find(this.documentFields, { field_name: fieldName });
    },
    saveDocument() {
      const documentState = get(this.documentToEdit, 'document_state', '');
      if (documentState === 'draft' || 'minute_draft') {
        this.openSaveDocumentModal = true;
      } else {
        this.saveAsDocGo();
      }
    },
    addField(field) {
      // const self = this;
      window.tinymce.activeEditor.execCommand(
        'mceInsertContent',
        false,
        `<span data-field class="mceNonEditable" style="${this.fieldStyle(field)}" id="${field.field_name}">${this.formatFieldValue(field.field_name, field.type) || field.alias}</span>`,
      );
    },
    fieldStyle(field) {
      if (field && field.required) {
        return `background: ${colors.red.lighten4}; line-height: 1.5; border-radius: 5px; padding: 3px; margin-right: 2px;`;
      } else if (field && field.required === undefined) {
        return `background: ${colors.yellow.lighten4}; line-height: 1.5; border-radius: 5px; padding: 3px; margin-right: 2px;`;
      }
      return `background: ${colors.green.lighten4}; line-height: 1.5; border-radius: 5px; padding: 3px; margin-right: 2px;`;
    },
    changeDocumentFieldValue() {
      this.html = this.reparseHtml();
      this.html = this.parseHtml();
    },
    formatFieldValue(fieldName, fieldType) {
      const field = find(this.documentFields, { field_name: fieldName });
      const defaultValue = get(field, 'alias', '');
      let fieldValue = this.filledFields[fieldName];

      if (fieldType === 'date') {
        fieldValue = fieldValue ? format(fieldValue, 'DD/MM/YYYY') : fieldValue;
      } else if (fieldType === 'cpf_cnpj') {
        fieldValue = fieldValue.length === 11 ?
          formatString('xxx.xxx.xxx-xx', fieldValue) : formatString('xx.xxx.xxx/xxxx-xx', fieldValue);
      } else if (fieldType === 'checkbox') {
        if (Array.isArray(fieldValue) && fieldValue.length > 1) {
          let fv = '';
          fieldValue.forEach((item, index) => {
            if (index === (fieldValue.length - 1)) {
              fv = fv.concat(`${item}`);
            } else {
              fv = fv.concat(`${item}, `);
            }
          });
          fieldValue = fv
        }
      }
      return fieldValue || defaultValue;
    },
    setDocumentFields() {
      let ff = [];
      ff = concat(ff, get(this.documentToEdit, 'document_type.fields.model_fields', []));
      ff = concat(ff, get(this.documentToEdit, 'document_type.fields.document_fields', []));
      const entity_fields = get(this.documentToEdit, 'document_type.fields.entity_fields', []); // eslint-disable-line
      if (entity_fields != null) { // eslint-disable-line
        ff = concat(ff, entity_fields);
      }
      ff = concat(ff, get(this.documentToEdit, 'document_type.fields.folder_fields', []));
      ff = concat(ff, get(this.documentToEdit, 'document_type.fields.other_fields', []));
      ff = concat(ff, get(this.documentToEdit, 'document_type.fields.transaction_fields', []));
      this.documentFields = Object.values(this.documentToEdit.document_type.fields).filter(i => i).reduce((accumulator, current) => ([...accumulator, ...current]));
    },
  },
  mounted() {
    this.$store.dispatch('getDocument', this.id);
  },
  watch: {
    documentToEdit(val) {
      if (!isEmpty(val) && val.document_versions.length > 0) {
        if (this.queryParams.documentModel) {
          if (this.queryParams.documentModel === 'default') {
            this.html = val.document_type.content_raw;
          }
        } else {
          this.html = last(val.document_versions).document_raw;
        }
        this.setDocumentFields();
        this.html = this.parseHtml();
      }
    },
  },
};
</script>

<style scoped>
.document-type-header {
  font-size: 14px;
}

.document-type-text {
  font-size: 18px;
  font-weight: 600;
}

.editor-container {
  overflow: hidden;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/document/editor/DocumentEditor.vue